var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-cp-frame--container",class:{
    'is-gray-background': _vm.isGrayBackground,
    'has-min-height': !_vm.disableMinHeight,
    'has-radius': _vm.hasRadius,
    'has-padding-bottom': _vm.hasPaddingBottom,
    'has-large-padding-bottom': _vm.hasLargePaddingBottom,
  }},[(_vm.$slots['side-menu'])?_c('div',{ref:"sideMenu",staticClass:"c-cp-frame--container__side-menu"},[_c('div',{staticClass:"c-cp-frame--container__side-menu-inner",class:{ 'is-fixed': _vm.isFixedSideBar },style:(_vm.sideMenuInnerStyle)},[_vm._t("side-menu")],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"c-cp-frame--container__main",class:{
      'is-max-width': _vm.isMaxWidth,
      'is-wide-container-width': _vm.isWideContainerWidth,
    }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }